import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class NewLoginService {

	constructor(private _http: HttpClient) {

	}

	/**
	 * @api {post} /v2/Customers/InetUsers Create Inet User
	 * @apiName createUser
	 * @apiGroup Customers
	 * @apiVersion 20.0.0
	 */
	createUser(data) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Customers/InetUsers`, JSON.stringify(data));
	}

	/**
	 * @api {post} /v2/InetUsers/UserNameExists Check if Username exists
	 * @apiName usernameIsValid
	 * @apiParam {string} [userName] Username
	 * @apiGroup InetUsers
	 * @apiVersion 20.0.0
	 */
	usernameIsValid(username) {
		return this._http.post<any>(`${environment.apiUrl}/v2/InetUsers/UserIdExists`, JSON.stringify(username));
	}
}
